var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-contant',[_vm._v(" Cancelled ")])
}
var staticRenderFns = []

export { render, staticRenderFns }